// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"ScenePlayer-moduleplayerWrapper2WS","disableRerecordButton":"ScenePlayer-moduledisableRerecordButton1-5"};